import React from 'react';

function Loader({small}) {
    const sizeClass = small ? 'loader__icon--small' : '';

    return (
        <div className="loader loader--full-screen">
            <p className="visually-hidden-accessible">Loading in progress.</p>
            <div className={`loader__icon ${sizeClass}`}/>
        </div>
    )
}

export default Loader;